import React from 'react'

function UserPlusIcon(props: any) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        fill: 'currentColor',
        viewBox: '0 0 24 16',
        'aria-hidden': 'true'
      },
      props
    ),
    React.createElement('path', {
      fill: 'currentColor',
      d: 'M5.25 6.375C5.25 4.09683 7.09683 2.25 9.375 2.25C11.6532 2.25 13.5 4.09683 13.5 6.375C13.5 8.65317 11.6532 10.5 9.375 10.5C7.09683 10.5 5.25 8.65317 5.25 6.375Z'
    }),
    React.createElement('path', {
      fill: 'currentColor',
      d: 'M2.25 19.125C2.25 15.19 5.43997 12 9.375 12C13.31 12 16.5 15.19 16.5 19.125V19.1276C16.5 19.1674 16.4996 19.2074 16.499 19.2469C16.4946 19.5054 16.3574 19.7435 16.1359 19.8768C14.1607 21.0661 11.8466 21.75 9.375 21.75C6.90343 21.75 4.5893 21.0661 2.61406 19.8768C2.39256 19.7435 2.25537 19.5054 2.25103 19.2469C2.25034 19.2064 2.25 19.1657 2.25 19.125Z'
    }),
    React.createElement('path', {
      d: 'M20.75 7.5C20.75 7.08579 20.4142 6.75 20 6.75C19.5858 6.75 19.25 7.08579 19.25 7.5V9.75H17C16.5858 9.75 16.25 10.0858 16.25 10.5C16.25 10.9142 16.5858 11.25 17 11.25H19.25V13.5C19.25 13.9142 19.5858 14.25 20 14.25C20.4142 14.25 20.75 13.9142 20.75 13.5V11.25H23C23.4142 11.25 23.75 10.9142 23.75 10.5C23.75 10.0858 23.4142 9.75 23 9.75H20.75V7.5Z',
      fill: props?.color ?? 'currentColor'
    })
  )
}

export default UserPlusIcon
